import { AuthConfig } from 'angular-oauth2-oidc'

export const authConfig: AuthConfig = {
  issuer: 'https://siemens-qa-mo.eu.auth0.com/',
  redirectUri: window.location.origin,
  clientId: 'pAhWftHFdIIIpHD7IohAvnw1usMFzsuf',
  customQueryParams: {
    connection: 'main-tenant-oidc',
    display: 'sup',
    audience: 'https://omp.spa.siemens.cloud',
  },
  showDebugInformation: true,
  responseType: 'code',
  scope: 'openid profile email offline_access',
  logoutUrl: 'https://wsi-ui.stg.damsy.siemens.cloud',
}
